module.exports = __webpack_public_path__ + "img/img15.2c151c36.svg";